<div class="mb-5">
  <h1 i18n>Application Management</h1>
  <p class="note py-0 my-0" i18n>Search for an application by name or description using the search bar below (enter 3 character or
    more to search).</p>
  <div>
    <div class="d-flex flex-column flex-md-row w-100 gap-3 m-0 col-12 lg:col-8 xl:col-6 pl-0 pr-3 lg:pr-0">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i class="pi pi-search"></i>
        </p-inputgroup-addon>
        <input
          pInputText
          type="text"
          (input)="search($event)"
          placeholder="Find by Name, Description, or Expert Code"/>
        <button type="button"
                class="p-button merge-left"
                aria-label="Add new application"
                (click)="createApplication()"
                (keydown.enter)="createApplication()" i18n>Create Application
        </button>
      </p-inputgroup>
    </div>
  </div>
  <div class="app-management mx-auto col-12 pl-0 pr-3">
    <p-table
      aria-label="Application Table"
      [value]="applications"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="p-datatable-striped"
      [globalFilterFields]="['Name', 'Title', 'Expert Code', 'Display Order']"
      [paginator]="true"
      [responsiveLayout]="'stack'"
      [rows]="pageSize"
      [rowsPerPageOptions]="[2,25,50,75,100]"
      [totalRecords]="totalRecords"
      [lazy]="true"
      [loading]="loading"
      (onLazyLoad)="loadApplications($event)"
      [showInitialSortBadge]="true"
      [customSort]="true">
      <ng-template pTemplate="header">
        <tr>
          <th id="Name" pSortableColumn="name">Name
            <p-sortIcon field="name"/>
          </th>
          <th id="Title" pSortableColumn="title">Title
            <p-sortIcon field="title"/>
          </th>
          <th id="Expert Code" pSortableColumn="expertCode">Expert Code
            <p-sortIcon field="expertCode"/>
          </th>
          <th id="Display Order" pSortableColumn="displayOrder">Display Order
            <p-sortIcon field="displayOrder"/>
          </th>
          <th id="Active or Locked" class="w-1rem"></th>
          <th id="edit" class="w-1rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-application>
        <tr pTooltip="{{ application.description }}" tooltipPosition="top" role="row">
          <td aria-labelledby="Application Name">{{ application.name }}</td>
          <td aria-labelledby="Application Title">{{ application.title }}</td>
          <td aria-labelledby="Expert Code">{{ application.expertCode }}</td>
          <td aria-labelledby="Display Order">{{ application.displayOrder }}</td>
          @if (application.locked) {
            <td aria-labelledby="Active or Locked"><i class="pi pi-lock"></i></td>
          } @else {
            <td aria-labelledby="Active or Locked"><i class="pi pi-lock-open"></i></td>
          }
          <td class="flex edit-cog" aria-labelledby="edit">
            <button class="edit-btn p-button-text p-button-icon-only" pButton type="button"
                    (click)="editApplication(application.id)">
              <i class="pi pi-cog"></i>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" i18n aria-live="polite">No Applications found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
